import React from "react"
import {FormattedDate, FormattedTime, FormattedNumber, FormattedPlural} from "react-intl"
import {FormattedMessage} from "./FormattedMessage"
import FormattedCurrency from "./common/FormattedCurrency"
import getSupportedLocale from "./helpers/getSupportedLocale"
import supportedLocal from "./helpers/supported.json"
import getResolvedMessage from "./helpers/getResolvedMessage"
import getMessage from "./helpers/getMessage"
import {formatDistanceToNow, Locale} from "date-fns"
export {LangLoader} from "./Loader"
export {useIntl} from "./intlHook"
export {injectIntl} from "./injectIntl"
export type {InjectIntl} from "./injectIntl"
export type {FormatMessage} from "./types"

export const FormattedRelative = React.memo(function FormattedRelativeTimeWrapped({value, locale}: {value?: string; locale?: Locale}) {
  if (!value) return null
  const text = formatDistanceToNow(new Date(value), {
    addSuffix: true,
    locale
  })
  return <span>{text}</span>
})
/** @see [format.js Components](https://formatjs.github.io/docs/react-intl/components) */
export {
  FormattedCurrency,
  FormattedDate,
  FormattedMessage,
  FormattedNumber,
  FormattedPlural,
  FormattedTime,
  getMessage,
  getResolvedMessage,
  getSupportedLocale,
  supportedLocal
}

export default FormattedMessage
